export const reservasPanels = {
  // OtaMessages.vue
  ota: {
    appTitle: "Attiva i messaggi OTA",
    installIntro:
      "Per rispondere ai tuoi ospiti di Booking.com / Airbnb da WA Checkin, devi installare l'app",
    installIntroTail: "sulla struttura.",
    installBtn: "Installa la messaggistica OTA",
    installing: "Installazione del modulo di messaggistica…",
    retryLink: "Ho già installato l'app, controlla di nuovo",
    loading: "Caricamento dei messaggi OTA…",
    empty: "Nessun messaggio OTA per questa prenotazione.",
    modeAi: "IA",
    modeManual: "Manuale",
    predefinedHeader: "Risposte rapide",
    predefinedEmpty: "Nessuna risposta corrispondente.",
    inputPlaceholder: "Scrivi un messaggio o usa / per le risposte rapide...",
    attachTitle: "Allega immagine",
    senderGuest: "Ospite",
    senderProperty: "Struttura",
    senderSystem: "Sistema",
    senderUnknown: "Sconosciuto",
    fileFallback: "file",
    toastTitle: "Messaggi OTA",
    errorTitle: "Errore",
    loadError: "Impossibile caricare i messaggi OTA.",
    modeErrorDetail: "Impossibile identificare la chat OTA. Prova a ricaricare la pagina.",
    modeManualOnTitle: "Modalità manuale attivata",
    modeAiOnTitle: "Agente IA attivato",
    modeManualOnDetail: "Risponderai ai messaggi manualmente",
    modeAiOnDetail: "Il bot risponderà automaticamente",
    modeChangeError: "Impossibile cambiare la modalità della chat OTA",
    sendError: "Impossibile inviare il messaggio OTA.",
    onlyImagesTitle: "Solo immagini",
    onlyImagesDetail: "Le OTA consentono di inviare solo immagini.",
    imageTooBigTitle: "Immagine troppo grande",
    imageTooBigDetail: "L'immagine non può superare i 5 MB.",
    installNoProperty: "Nessuna struttura collegata a Channex trovata.",
    installOk: "Applicazione installata correttamente.",
    installError: "Impossibile installare l'applicazione.",
  },

  // ReservationNotes.vue
  notes: {
    composerPlaceholder: "Scrivi una nota interna…",
    saveHint: "⌘ / Ctrl + Invio per salvare",
    saving: "Salvataggio…",
    addNote: "Aggiungi nota",
    loading: "Caricamento delle note…",
    emptyTitle: "Ancora nessuna nota",
    emptyText: "Aggiungi la prima nota interna dal riquadro qui sopra.",
    cancel: "Annulla",
    save: "Salva",
    team: "Team",
    confirmDelete: "Eliminare?",
    yes: "Sì",
    no: "No",
    editTitle: "Modifica",
    deleteTitle: "Elimina",
    loadError: "Impossibile caricare le note",
    added: "Nota aggiunta",
    saveError: "Impossibile salvare la nota",
    updated: "Nota aggiornata",
    updateError: "Impossibile aggiornare la nota",
    deleted: "Nota eliminata",
    deleteError: "Impossibile eliminare la nota",
  },

  // ReservationPaymentsPanel.vue
  payments: {
    pendingLabel: "In sospeso",
    paidLabel: "Incassato",
    totalLabel: "Totale",
    loading: "Caricamento dei pagamenti…",
    empty: "Nessun pagamento ancora registrato.",
    addPayment: "Aggiungi pagamento…",
    fullyPaid: "Prenotazione interamente pagata",
    recalcTitle: "Ricalcola",
    sendWhatsappTitle: "Invia tramite WhatsApp",
    copyLinkTitle: "Copia link",
    editAction: "Modifica",
    deleteAction: "Elimina",
    modalEditTitle: "Modifica pagamento",
    modalAddTitle: "Aggiungi pagamento",
    amountLabel: "Importo da addebitare",
    fillRemaining: "Addebita il rimanente ({amount})",
    methodLabel: "Metodo di pagamento",
    sendWhatsappCheck: "Invia il link all'ospite tramite WhatsApp",
    noteLabel: "Nota (opzionale)",
    notePlaceholder: "Es. caparra, pagamento all'arrivo…",
    cancel: "Annulla",
    save: "Salva",
    generateLink: "Genera link",
    registerPayment: "Registra pagamento",
    deleteConfirmTitle: "Eliminare questo pagamento?",
    deleteText1: "Verrà eliminato il pagamento di",
    deleteLinkVoided: "Il link di pagamento verrà annullato.",
    deleteIrreversible: "Questa azione non può essere annullata.",
    deleteBtn: "Elimina pagamento",
    sendConfirmTitle: "Inviare il link di pagamento?",
    sendText1: "All'ospite verrà inviato il link per pagare tramite WhatsApp per",
    sendBtn: "Invia link",
    methodCash: "Contanti",
    methodCard: "Carta / terminale fisico",
    methodTransfer: "Bonifico bancario",
    methodOta: "Pagato tramite OTA",
    statusPaid: "Incassato",
    statusPending: "In sospeso",
    statusFailed: "Fallito",
    statusCancelled: "Annullato",
    loadError: "Impossibile caricare i pagamenti.",
    amountRequired: "Inserisci un importo.",
    saveError: "Impossibile salvare il pagamento.",
    deleteError: "Impossibile eliminarlo.",
    sendLinkError: "Impossibile inviare il link.",
    recalcError: "Impossibile ricalcolare.",
  },

  // RoomAssignmentPanel.vue
  roomAssign: {
    title: "Assegna camera",
    subWithUnitPre: "Questa prenotazione per",
    subWithUnitPost: "non ha ancora una camera fisica assegnata.",
    subNoUnit: "Questa prenotazione non ha ancora una camera fisica assegnata.",
    loading: "Verifica della disponibilità…",
    freePre: "Camere disponibili per",
    freePost: "Scegline una e assegnala direttamente:",
    freeBadge: "Libera",
    assigning: "Assegnazione…",
    occupiedNote:
      "{count} camera occupata in queste date | {count} camere occupate in queste date",
    noneFreeTitle: "Non ci sono camere libere per queste date.",
    noFreePre: "Tutte le camere di",
    thisType: "questo tipo",
    noFreeMid:
      "sono occupate o bloccate il {date}. Per assegnare questa prenotazione,",
    reorganizeBold: "riorganizza le prenotazioni",
    noFreeMid2: "di questo tipo di camera dal calendario (con il pulsante",
    organizeBtn: "Organizza",
    noFreeTail: ") per liberarne una.",
    tagMaintenance: "Manutenzione",
    tagBlocked: "Bloccata",
    theseDates: "queste date",
    occupied: "Occupata",
    assignedOk: "Camera {label} assegnata correttamente.",
    assignError: "Impossibile assegnare la camera.",
    notifyError: "Errore",
    notifyDone: "Fatto",
  },

  // GroupRoomsPanel.vue
  groupRooms: {
    heading: "Camere in questa prenotazione",
    typesCount: "{count} tipo | {count} tipi",
    roomsCount: "{count} camera | {count} camere",
    guestsCount: "{count} ospite | {count} ospiti",
    totalLabel: "Totale",
    viewingBadge: "In visualizzazione",
    noRoomAssigned: "Nessuna camera assegnata",
    removeOneRoom: "Rimuovi una camera",
    addOneRoom: "Aggiungi una camera",
    confirmRemove: "Rimuovere?",
    yes: "Sì",
    no: "No",
    cannotRemoveOnly: "Non puoi rimuovere l'unica camera",
    removeRoomFromBooking: "Rimuovi questa camera dalla prenotazione",
    updating: "Aggiornamento…",
    theChannel: "il canale",
    otaManaged:
      "Questa camera è gestita da {channel}: quantità e prezzo si modificano lì.",
    notifyError: "Errore",
    notifyDone: "Fatto",
    qtyUpdated: "Quantità aggiornata",
    roomRemoved: "Camera rimossa dalla prenotazione",
    updateError: "Impossibile aggiornare la prenotazione. Riprova.",
  },
};
